(function () {
  const personaliseOptOut = document.getElementById('personaliseOptOut');
  const personaliseFieldsets = document.querySelectorAll('.js-personalise-fieldset');

  if (personaliseOptOut) {
    personaliseOptOut.addEventListener('change', function () {
      personaliseFieldsets.forEach(elem => {
        if (this.checked) {
          elem.setAttribute('disabled', '');
        } else {
          if (elem.nodeName.toLowerCase() === 'fieldset' && elem.classList.contains('hidden')) return;
          elem.removeAttribute('disabled');
        }
      });
    });
  }

  // Font dropdowns
  const fontDropdowns = document.querySelectorAll('[data-personalise-font]');
  fontDropdowns.forEach(select => {
    select.addEventListener('change', e => {
      const imageAsset = e.target.selectedOptions[0].dataset.fileName;
      if (imageAsset) {
        e.target.setAttribute('data-font-bg', imageAsset);
      }
    });
  });

  // Accordions
  const accordions = document.querySelectorAll('[data-personalise-accordion]');
  accordions.forEach(accordion => {
    const toggle = accordion.querySelector('.personalise-form__options--checkbox');
    toggle?.addEventListener('change', () => {
      const body = accordion.querySelector('[data-personalise-body]');
      if (toggle.checked) {
        body.classList.remove('hidden');
        body.removeAttribute('disabled');
        body.setAttribute('aria-hidden', false);
      } else {
        body.classList.add('hidden');
        body.disabled = true;
        body.setAttribute('aria-hidden', true);
      }
    });
  });

  // Tab content
  const tabLinks = document.querySelectorAll('[data-form-toggle]');
  tabLinks.forEach(link => {
    link.addEventListener('click', () => {
      let linkContainer =
        link.closest('[data-personalise-container]') ||
        link.closest('[data-personalise-accordion]') ||
        link.closest('#personaliseForm');

      const tabsContent = linkContainer.querySelectorAll('[data-form-tab]');
      tabsContent.forEach(tab => {
        tab.classList.add('hidden');
        tab.setAttribute('aria-hidden', true);
        if (tab.nodeName === 'FIELDSET') tab.disabled = true;
      });

      const target = linkContainer.querySelector(`[data-form-tab="${link.getAttribute('data-form-toggle')}"]`);
      if (target && link.getAttribute('data-form-toggle').toUpperCase() !== 'NONE') {
        target.classList.remove('hidden');
        target.removeAttribute('aria-hidden');
        if (target.nodeName === 'FIELDSET') target.disabled = false;
      }
    });
  });

  // Auto-select and trigger first radio option if no selection has been made
  document.querySelectorAll('ul.personalise-form__radio-buttons').forEach(radioList => {
    const radios = radioList.querySelectorAll('input[type="radio"]');
    if (!radios.length) return;

    const alreadyChecked = Array.from(radios).some(radio => radio.checked);
    if (alreadyChecked) return;

    for (const radio of radios) {
      const tabKey = radio.getAttribute('data-form-toggle');
      const tab = document.querySelector(`[data-form-tab="${tabKey}"]`);

      if (tab && !tab.classList.contains('hidden')) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  });

  if (!customElements.get('product-form')) {
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        if (this.hasChildNodes()) this.init();
      }

      init() {
        this.form = this.querySelector('.js-product-form');
        if (!this.form) return;

        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      async handleSubmit(evt) {
        if (evt.target.id === 'product-signup_form') return;
        evt.preventDefault();

        const formHasPersonalisation =
          this.querySelector('.js-personalise-fieldset') ||
          this.querySelector('#personaliseOptOut');

        if (formHasPersonalisation) {
          const hasOptedOut = document.getElementById('personaliseOptOut')?.checked || false;
          const personaliseOptions = document.querySelectorAll('[data-personalise-option]');
          const hasCheckedOptions = Array.from(personaliseOptions).some(option => option.checked);

          const visibleTextInputs = Array.from(document.querySelectorAll('input[type="text"], textarea'))
            .filter(input => !input.closest('.hidden') && input.offsetParent !== null)
            .filter(input => input.value.trim() !== '');

          const hasBeenPersonalised = hasCheckedOptions || visibleTextInputs.length > 0;

          if (!hasBeenPersonalised && !hasOptedOut) {
            this.setErrorMsgState('Missing personalization options. Opt out of personalizing using the button above.');
            return;
          }

          if (!hasOptedOut) {
            const visibleAccordions = Array.from(document.querySelectorAll('[data-personalise-accordion]'))
              .filter(acc => {
                const body = acc.querySelector('[data-personalise-body]');
                return body && !body.classList.contains('hidden');
              });

            let invalidAccordion = false;

            visibleAccordions.forEach(accordion => {
              const inputs = accordion.querySelectorAll('input, select, textarea');

              const visibleInputs = Array.from(inputs).filter(input => {
                const style = window.getComputedStyle(input);
                return style.display !== 'none' &&
                  style.visibility !== 'hidden' &&
                  !input.closest('.hidden');
              });

              const textInputs = visibleInputs.filter(
                input => input.type === 'text' || input.tagName.toLowerCase() === 'textarea'
              );

              const otherInputs = visibleInputs.filter(
                input => !(input.type === 'text' || input.tagName.toLowerCase() === 'textarea')
              );

              const anyTextFilled =
                textInputs.length === 0 ||
                textInputs.some(input => input.value.trim() !== '');

              const allOtherFilled =
                otherInputs.every(input => input.value && input.value.trim() !== '');

              if (!anyTextFilled || !allOtherFilled) {
                invalidAccordion = true;
              }
            });

            if (invalidAccordion) {
              this.setErrorMsgState(
                'Please complete all required personalisation fields in each section.'
              );
              return;
            }
          }
        }

        if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;
        if (theme.settings.vibrateOnATC && window.navigator.vibrate) window.navigator.vibrate(100);

        this.errorMsg = null;
        this.setErrorMsgState();
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');

        try {
          const optOutCheckbox = document.getElementById('personaliseOptOut');
          if (optOutCheckbox) {
            let activeSku = document.querySelector('.product-sku__value').innerText;
            if (optOutCheckbox.checked && activeSku.includes('-PERS')) {
              activeSku = activeSku.replace('-PERS', '');
            } else if (!optOutCheckbox.checked && !activeSku.includes('-PERS')) {
              activeSku += '-PERS';
            }
            const newSku = this.form.querySelector(`input[type="hidden"][data-sku*="${activeSku}"]`)?.dataset.id;
            if (newSku) this.form.querySelector('[name="id"]').value = newSku;
          }
        } catch (error) {
          this.setErrorMsgState('There was an error adding this product to your basket');
          console.error('Add to Cart Error', error);
        }

        const formData = new FormData(this.form);
        let sections = 'cart-icon-bubble';
        if (this.cartDrawer) {
          sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
        }

        formData.append('sections_url', window.location.pathname);
        formData.append('sections', sections);

        const fetchRequestOpts = {
          method: 'POST',
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        };

        try {
          const oldCartData = await (await fetch(`${theme.routes.cart}.js`)).json();
          const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
          const data = await response.json();

          let error = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors && typeof data.errors === 'object') {
            error = Object.entries(data.errors).map(item => item[1].join(', '));
          }

          if (data.status || !response.ok) {
            this.setErrorMsgState(error);
            throw new Error(error);
          }

          if (theme.settings.afterAtc === 'page') {
            setTimeout(() => {
              window.location.href = theme.routes.cart;
            }, 300);
          } else {
            ProductForm.updateCartIcon(data);

            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) quickAddDrawer.addedToCart();

            setTimeout(() => {
              if (this.cartDrawer) {
                this.cartDrawer.renderContents(data, !quickAddDrawer && theme.settings.afterAtc === 'drawer');
              } else if (window.location.pathname === theme.routes.cart) {
                document.querySelector('cart-items')?.refresh?.();
              }
            }, 700);
          }

          const newCartData = await (await fetch(`${theme.routes.cart}.js`)).json();
          const itemInOldCart = oldCartData.items.find(item => item.variant_id === data.variant_id);

          if (itemInOldCart) {
            this.dispatchEvent(new CustomEvent('on:line-item:change', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id,
                oldQuantity: itemInOldCart.quantity,
                newQuantity: itemInOldCart.quantity === data.quantity ? itemInOldCart.quantity : data.quantity
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent('on:cart:add', {
              bubbles: true,
              detail: {
                cart: newCartData,
                variantId: data.variant_id
              }
            }));

            window.dataLayer?.push({ ecommerce: null });
            window.dataLayer?.push({
              event: 'add_to_cart',
              ecommerce: {
                currency: window._currencysignCustom,
                value: Number(data.price / 100),
                items: [{
                  item_name: data.product_title,
                  item_id: data.sku,
                  price: Number(data.price / 100),
                  item_brand: data.vendor,
                  item_category: data.product_type,
                  item_variant: data.variant_title,
                  in_stock: 'yes',
                  on_offer: data.total_discount != 0 ? 'yes' : 'no',
                  index: 0,
                  quantity: data.quantity
                }]
              }
            });
          }
        } catch (error) {
          console.error('Cart Error:', error);
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: this.errorMsg?.textContent || 'Unknown error'
            }
          }));
        } finally {
          this.submitBtn.classList.add('is-success');
          this.submitBtn.removeAttribute('aria-disabled');
          setTimeout(() => {
            this.submitBtn.classList.remove('is-loading', 'is-success');
          }, 1400);
        }
      }

      submitForm() {
        this.errorMsg = null;
        this.setErrorMsgState();
        this.submitBtn.setAttribute('aria-disabled', 'true');
        this.submitBtn.classList.add('is-loading');
        this.form.submit();
      }

      static updateCartIcon(response) {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && response.sections) {
          cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
        }
      }

      setErrorMsgState(error = false) {
        this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
        if (!this.errorMsg) return;

        this.errorMsg.hidden = !error;
        if (error) {
          this.errorMsg.innerHTML = '';
          (Array.isArray(error) ? error : [error]).forEach((err, index) => {
            if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
            this.errorMsg.insertAdjacentText('beforeend', err);
          });
        }
      }
    }

    customElements.define('product-form', ProductForm);
  }
})();
